<template>
  <div>
    <autoLogout />
    <loader :loader="loader || sending" />
    <div class="wrapper-content">
      <encabezado
        :elementos="encabezado"
        :nameRoute="nameRoute"
        :paramsRoute="paramsRoute"
      />
      <v-card>
        <v-card-text>
          <v-container>
            <v-row dense v-if="info && info.idPatient">
              <v-col>
                <patient-information :model="info" @patientLoaded="handlePatientLoaded" />
              </v-col>
            </v-row>
            <!-- <v-row dense class="ml-2">
              <v-col md="4" sm="12" cols="12" v-if="info.phone">
                <strong>Teléfono móvil: </strong>
                {{ info.phone || "N/A" }}</v-col
              >
              <v-col md="4" sm="12" cols="12" v-if="info.homePhone">
                <strong>Teléfono fijo: </strong>
                {{ info.homePhone || "N/A" }}
              </v-col>
              <v-col md="4" sm="12" cols="12" v-if="info.email">
                <strong>Correo electrónico: </strong>
                {{ info.email || 'N/A' }}
              </v-col>
            </v-row>
            <v-row dense class="ml-2" v-if="info.address">
              <v-col md="12" sm="12" cols="12">
                <strong>Dirección: </strong>
                {{ info.address }}
              </v-col>
            </v-row> -->
            <v-row dense v-if="info && info.idStudy">
              <v-col>
                <study-information :model="info" />
              </v-col>
            </v-row>

            <v-row dense v-if="filePreviews.length" class="mt-4">
              <v-col cols="12">
                <v-subheader>
                  <v-icon left>mdi-file-document</v-icon>
                  Archivos del estudio
                </v-subheader>
                <v-list two-line>
                  <v-list-item
                    v-for="(file, i) in filePreviews"
                    :key="i"
                  >
                    <v-list-item-icon>
                      <v-icon color="red">mdi-file-pdf-box</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{ file.fileName }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn small text @click="viewFile(file)">
                        Ver <v-icon right small>mdi-open-in-new</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <!-- Botones de Cancelar y Cerrar estudio -->
        <div class="container" v-if="!visible">
          <v-row class="my-5" align="center" justify="center">
            <v-col cols="10">
              <v-row align="center" justify="center">
                <v-col class="text-center">
                  <v-btn
                    color="error"
                    @click="cancel()"
                    v-show="showStatus()"
                    :disabled="sending"
                    outlined
                    v-if="
                      (speciality == 3 &&
                        $utilFront.withPermission($prm.LABORATORY_CANCEL)) ||
                      (speciality == 2 &&
                        $utilFront.withPermission($prm.IMAGE_CANCEL))
                    "
                    >Cancelar estudio <v-icon right>mdi-stop</v-icon></v-btn
                  >
                </v-col>
                <v-col class="text-center">
                  <v-btn
                    color="warning"
                    @click="close()"
                    :disabled="sending"
                    outlined
                    v-show="showStatus()"
                    v-if="
                      (speciality == 3 &&
                        $utilFront.withPermission($prm.LABORATORY_VALIDATE)) ||
                      (speciality == 2 &&
                        $utilFront.withPermission($prm.IMAGE_CLOSE))
                    "
                    >{{ titleClose }}
                    <v-icon right>mdi-folder-lock</v-icon></v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>

        <!-- Botones de Cancelar e Iniciar estudio -->
        <div class="container" v-if="visible">
          <div class="d-flex justify-center">
            <v-col class="d-flex justify-space-around">
              <!-- <div v-on:click="confirmCancel()">
                <btn-accion :elements="btnCancell" />
              </div> -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="btnCancell.color"
                    :to="btnCancell.route"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    v-on:click="confirmCancel()"
                    :disabled="sending"
                    v-if="
                      (speciality == 3 &&
                        $utilFront.withPermission($prm.LABORATORY_CANCEL)) ||
                      (speciality == 2 &&
                        $utilFront.withPermission($prm.IMAGE_CANCEL))
                    "
                    outlined
                  >
                    <v-icon left>{{ btnCancell.icon }}</v-icon>
                    {{ btnCancell.text }}
                  </v-btn>
                </template>
                <span>{{ btnCancell.tooltip }}</span>
              </v-tooltip>

              <!-- <div v-on:click="confirmBegin()">
                <btn-accion :elements="btnBegin"  />
              </div> -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="btnBegin.color"
                    :to="btnBegin.route"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    v-if="
                      (speciality == 3 &&
                        $utilFront.withPermission($prm.LABORATORY_STARTS)) ||
                      (speciality == 2 &&
                        $utilFront.withPermission($prm.IMAGE_STARTS))
                    "
                    v-on:click="confirmBegin()"
                    :disabled="sending"
                    outlined
                  >
                    <v-icon left>{{ btnBegin.icon }}</v-icon>
                    {{ btnBegin.text }}
                  </v-btn>
                </template>
                <span>{{ btnBegin.tooltip }}</span>
              </v-tooltip>
            </v-col>
          </div>
        </div>

        <div class="container" v-if="visible2">
          <v-divider class="mb-8"></v-divider>
          <div class="d-flex justify-center">
            <v-col class="d-flex justify-space-around">
              <v-btn
                color="warning"
                @click="downloadViewer(info.idStudy)"
                :disabled="sending"
                v-if="$utilFront.withPermission($prm.IMAGE_VISUALIZER)"
                class="mr-2"
              >
                <v-icon color="white" dark left>mdi mdi-eye</v-icon>
                Visualizador
              </v-btn>

              <view-image-button
                v-if="
                  speciality == 2 &&
                  $utilFront.withPermission($prm.VIEWER_WEB_IMG)
                "
                :send="() => (sending = !sending)"
                :sending="sending"
                :idStudy="item.idStudy"
              />

              <v-btn
                color="blue"
                class="mr-2"
                @click="downloadZIP(info.idStudy)"
                v-if="$utilFront.withPermission($prm.DOWNLOAD_DICOM)"
                :disabled="sending"
              >
                <v-icon color="white" dark left>mdi-folder-download</v-icon>
                Archivos DICOM
              </v-btn>

              <v-btn
                v-if="info.status == 6 && info.statusInterpretation != 2"
                color="error"
                class="mr-2"
                :disabled="sending"
                @click="downloadInterpretation(info.idStudy)"
              >
                <v-icon color="white" dark left> mdi-file-pdf-box </v-icon>
                Descargar
              </v-btn>
            </v-col>
          </div>
        </div>

        <v-card-actions>
          <v-row align="center" justify="center">
            <v-col cols="10" class="text-center my-3">
              <v-btn color="error" outlined @click="$router.go(-1)">
                <v-icon left>mdi-chevron-left</v-icon> Volver
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>

    <!-- INICIAR ESTUDIO -->
    <v-dialog v-model="dialog" persistent max-width="1000">
      <v-card>
        <v-card-title class="text-h6 text-center success--text">
          ¿Desea iniciar este estudio?
        </v-card-title>
        <div class="container">
          <v-subheader
            ><v-icon> mdi-account-edit </v-icon>Datos Generales del Paciente
          </v-subheader>
          <v-divider class="mb-5"></v-divider>
          <v-row align="center">
            <v-col>
              <p class="font-weight-black">
                Nombre completo:<br />
                <span class="font-weight-regular">{{
                  info.fullNamePatient
                }}</span>
              </p>
            </v-col>
            <v-col>
              <p class="font-weight-black">
                Fecha de nacimiento:<br />
                <span class="font-weight-regular">{{ info.nacPatient }}</span>
              </p>
            </v-col>
            <v-col>
              <p class="font-weight-black">
                Sexo:<br />
                <span class="font-weight-regular">{{ info.sexPatient }}</span>
              </p>
            </v-col>
          </v-row>
          <br />
          <v-subheader
            ><v-icon> mdi-clipboard-text </v-icon>Datos Generales del Estudio
          </v-subheader>
          <v-divider class="mb-5"></v-divider>
          <v-row align="center">
            <v-col>
              <p class="font-weight-black">
                Modalidad:<br />
                <span class="font-weight-regular">{{ info.modality }}</span>
              </p>
            </v-col>
            <v-col>
              <p class="font-weight-black">
                Estudio:<br />
                <span class="font-weight-regular">{{
                  info.studyModality
                }}</span>
              </p>
            </v-col>
            <v-col>
              <p class="font-weight-black">
                Id Estudio:<br />
                <span class="font-weight-regular">{{ info.idStudy }}</span>
              </p>
            </v-col>
          </v-row>
          <v-row v-if="speciality != 3">
            <v-col>
              <p class="font-weight-black success--text">
                Accession Number:<br />
                <span class="font-weight-black">{{
                  info.accessionNumber
                }}</span>
              </p>
            </v-col>
          </v-row>
          <br />
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialog = false"> Cancelar </v-btn>

          <v-btn
            v-if="speciality == 3"
            color="primary"
            text
            :disabled="sending || !valid"
            @click="
              dialog = false;
              beginStudy();
            "
          >
            Aceptar
          </v-btn>
          <v-btn
            v-if="speciality == 2"
            color="primary"
            text
            :disabled="sending"
            @click="
              dialog = false;
              beginStudy();
            "
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Cancelar Estudio -->
    <v-dialog v-model="dialog2" persistent max-width="1000">
      <v-card>
        <v-card-title class="text-h6 text-center error--text">
          ¿Desea cancelar este estudio?
        </v-card-title>

        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <h3 class="font-weight-black">
                    Datos generales del paciente
                  </h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    :value="info.fullNamePatient"
                    label="Paciente"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    :value="info.nacPatient"
                    label="Fecha de nacimiento"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    :value="info.sexPatient"
                    label="Sexo"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3 class="font-weight-black">Datos generales del estudio</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    :value="info.modality"
                    label="Modalidad"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    :value="info.studyModality"
                    label="Estudio"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col>
                  <v-text-field
                    :value="info.idStudy"
                    label="Id Estudio"
                    disabled
                  ></v-text-field>
                </v-col>
              </v-row>
              <!-- <v-row v-if=" speciality != 3">

                <v-col>
                  <h3 class="font-weight-black primary--text">
                    Accession Number: {{ info.accessionNumber }}
                  </h3>
                </v-col>
              </v-row> -->
              <v-row>
                <v-col v-if="speciality == 2">
                  <h3 class="font-weight-black primary--text">
                    Accession Number: {{ info.accessionNumber }}
                  </h3>
                </v-col>
                <v-col v-if="speciality == 3">
                  <h3 class="font-weight-black primary--text">
                    Id Etiqueta: {{ info.laboratoryLabel }}
                  </h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <h3 class="font-weight-black mt-5">Motivo</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <v-row>
                      <v-col
                        @click.right.prevent
                        @copy.prevent
                        @paste.prevent
                        ondrop="return false;"
                      >
                        <validation-provider
                          v-slot="{ errors }"
                          name="Motivo"
                          rules="required"
                        >
                          <v-textarea
                            outlined
                            v-model="reason"
                            :value="reason"
                            :error-messages="errors"
                            label="Motivo de cancelación"
                            id="cancellation"
                            :counter="200"
                            :maxlength="200"
                            required
                          ></v-textarea>
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions class="text-center">
            <v-col>
              <v-btn color="error" plain @click="closeCancel()">
                Cancelar <v-icon right>mdi-close</v-icon>
              </v-btn></v-col
            >
            <v-col>
              <v-btn
                :disabled="sending || invalid"
                color="primary"
                @click="cancelStudy()"
              >
                Cancelar estudio <v-icon right>mdi-stop</v-icon>
              </v-btn></v-col
            >
          </v-card-actions>
        </validation-observer>
      </v-card>
    </v-dialog>

    <!-- Cerrar estudio -->
    <v-dialog v-model="dialogCloseStudy" persistent max-width="1000">
      <v-card>
        <v-card-title class="text-h6 text-center success--text">
          ¿Desea cerrar éste estudio?
        </v-card-title>
        <!-- <v-card-text>Id Estudio: {{ info.idStudy }} </v-card-text>
            <v-card-text>Paciente:{{ info.fullNamePatient }}</v-card-text>
            <v-card-text v-if="speciality == 2"
              >Imágenes: {{ quantityImages }}</v-card-text
            > -->
        <div class="container">
          <!-- <v-card-text>Id Estudio: {{ dataModal.idStudy }} </v-card-text>
          <v-card-text>
            Paciente:
            {{ dataModal.fullNamePatient }}
          </v-card-text> -->
          <!-- Primer Tabla -->

          <v-subheader
            ><v-icon> mdi-account-edit </v-icon>Datos Generales del Paciente
          </v-subheader>
          <v-divider class="mb-5"></v-divider>
          <v-row align="center">
            <v-col>
              <p class="font-weight-black">
                Nombre completo:<br />
                <span class="font-weight-regular">{{
                  info.fullNamePatient
                }}</span>
              </p>
            </v-col>
            <v-col>
              <p class="font-weight-black">
                Fecha de nacimiento:<br />
                <span class="font-weight-regular">{{ info.nacPatient }}</span>
              </p>
            </v-col>
            <v-col>
              <p class="font-weight-black">
                Sexo:<br />
                <span class="font-weight-regular">{{ info.sexPatient }}</span>
              </p>
            </v-col>
          </v-row>
          <br />
          <v-subheader
            ><v-icon> mdi-clipboard-text </v-icon>Datos Generales del Estudio
          </v-subheader>
          <v-divider class="mb-5"></v-divider>
          <v-row align="center">
            <v-col>
              <p class="font-weight-black">
                Modalidad:<br />
                <span class="font-weight-regular">{{ info.modality }}</span>
              </p>
            </v-col>
            <v-col>
              <p class="font-weight-black">
                Estudio:<br />
                <span class="font-weight-regular">{{
                  info.studyModality
                }}</span>
              </p>
            </v-col>
            <v-col>
              <p class="font-weight-black">
                Id Estudio:<br />
                <span class="font-weight-regular">{{ info.idStudy }}</span>
              </p>
            </v-col>
          </v-row>
          <v-row v-if="speciality != 3">
            <v-col>
              <p class="font-weight-black success--text">
                Accession Number:<br />
                <span class="font-weight-black">{{
                  info.accessionNumber
                }}</span>
              </p>
            </v-col>
            <v-col>
              <p class="font-weight-black success--text">
                Imágenes:<br />
                <span class="font-weight-black">{{ quantityImages }}</span>
              </p>
            </v-col>
          </v-row>
          <br />
        </div>
        <!--
            <div v-if="speciality == 3">
               <p style="text-align: center">
              Tipo de estudio: {{ laboratoryResults.tipoEstudio }}
            </p> 
              <v-simple-table dense fixed-header>
                <thead>
                  <tr>
                    <th>Parametro</th>
                    <th>Resultados</th>
                    <th>Unidad</th>
                    <th>V. de Referencia</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(lab, index) in laboratoryResults.resultados"
                    :key="lab.parametro"
                    :id="index"
                  >
                    <td>
                      <b>{{ lab.parametro }}</b
                      ><br />Método: {{ lab.resultados.tecnica }}<br />Muestra:
                      {{ lab.resultados.tipo }}
                    </td>
                    <td>{{ lab.resultados.resultadoNumb }}</td>
                    <td>{{ lab.resultados.unidadmedida }}</td>
                    <td v-html="lab.resultados.val_ref"></td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div> -->
        <div class="container">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-textarea
              outlined
              v-model="reasonClose"
              :value="reasonClose"
              label="Observación (opcional)"
              :counter="300"
              :maxlength="300"
            ></v-textarea>
          </v-form>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="dialogCloseStudy = false">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="
              dialogCloseStudy = false;
              closeStudy(info.idStudy);
            "
            :disabled="sending"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";
import StudyInformation from "@/app/components/interpretation/PatientInterpretationAppoInfo.vue";
import moment from "moment";
import Datatable from "../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../components/Sidebar";
import BtnAccion from "../components/btnAccion.vue";
import {
  StudyRequest,
  ReportPDFRequest,
  DownloadZipRequest,
} from "@/core/request";
import { mapActions } from "vuex";
import AutoLogout from "../components/AutoLogout.vue";
import Loader from "@/components/Loader.vue";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "{_field_} no puede quedar vacío",
});

import ViewImageButton from "@/app/components/common/study/ViewImageButton.vue";

export default {
  name: "DetalleEstudio",
  components: {
    PatientInformation,
    StudyInformation,
    Sidebar,
    Encabezado,
    Datatable,
    BtnAccion,
    AutoLogout,
    Loader,
    ValidationObserver,
    ValidationProvider,
    ViewImageButton,
  },
  data() {
    return {
      nameRoute: "IniciarEstudio",
      sending: false,
      loader: false,
      paramsRoute: {},
      prevRoute: null,
      acronym: "TD",
      valid: true,
      dialog: false,
      dialog2: false,
      dialogCloseStudy: false,
      visible: false,
      visible2: false,
      reason: "",
      speciality: "",
      laboratoryResults: {},
      encabezado: {
        icono: "mdi-text-box-search",
        texto: "Detalles del Estudio",
      },
      item: {},
      info: {},
      service: StudyRequest,
      btnCancell: {
        icon: "mdi-close",
        text: "Cancelar estudio",
        tooltip: "Cancelar estudio",
        color: "error",
      },
      btnBegin: {
        icon: "mdi-play",
        text: "Iniciar estudio",
        tooltip: "Iniciar estudio",
        color: "success",
        disabled: true,
      },
      reasonRules: [(v) => !!v || "El motivo de la cancelación es obligatorio"],
      quantityImages: 0,
      quantity: 1,
      dataModal: "",
      reasonClose: "",
      list: [],
      quantityRules: [
        (v) => !!v || "La cantidad de etiquetas es obligatorio",
        (v) => (v && v > 0) || "La cantidad de etiquetas es obligatorio",
      ],
      titleClose: "Cerrar estudio",
      colposcopyFiles: null,
      filePreviews: [],
    };
  },
  created() {
    let speciality1 = localStorage.getItem("speciality");
    this.speciality = this.$route.params.speciality;
    if (this.speciality == undefined || this.speciality == "") {
      this.speciality = speciality1;
      if (this.$utilFront.isEmpty(speciality1)) {
        if (this.$route.path.includes("imagen")) {
          this.speciality = 2;
        } else if (this.$route.path.includes("laboratorio")) {
          this.speciality = 3;
        } else {
          this.speciality = 2;
        }
      }
    } else {
      localStorage.setItem("speciality", this.speciality);
    }
  },
  beforeMount() {
    this.getStudy();
  },
  mounted() {
    this.validBrowserTab();
    this.validateData();
    this.titleClose =
      this.speciality == 2 ? "Cerrar estudio" : "Validar estudio";
      console.log("item", item)
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    resetValidation() {
      this.$refs.form.reset();
    },
    getStudy() {
      this.sending = true;
      let id = localStorage.getItem("idStudy");
      let post = {
        idStudy: id,
      };
      StudyRequest.getStudy(post).then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.item = res.data.data;
          let address = `${this.item.address.street} #${this.item.address.outdoorNumber},
          ${this.item.address.colonyKey}, ${this.item.address.municipalityKey},
          ${this.item.address.federalEntityKey}, ${this.item.address.postalCode}`;
          address = address
            .replace("null", "")
            .replace("  ", " ")
            .replace("\n", " ")
            .replace("\n ", " ");
          let birthDate =
            moment(new Date(this.item.birthDate))
              .locale("es")
              .format("DD/MM/YYYY") || "---";

          this.info = {
            idPatient: this.item.idPatient,
            idStudy: this.item.idStudy,
            fullNamePatient: this.item.fullNamePatient,
            gender: this.item.sexPatient,
            curp: this.item.curpPatient,
            birthDate: birthDate,
            address: address,
            phone: this.item.phoneNumber,
            homePhone: this.item.homePhone,
            email: this.item.email,
            studyModality: this.item.nameStudy,
            modality: this.item.nameModality,
            status: this.item.status,
            statusInterpretation: this.item.statusInterpretation || 0,
            accessionNumber: this.item.accessionNumber,
            registrationDate:
              moment(new Date(this.item.registrationDateStudy))
                .locale("es")
                .format("DD/MM/YYYY HH:mm") || "---",
            nacPatient:
              moment(new Date(this.item.birthDate))
                .locale("es")
                .format("DD/MM/YYYY") || "---",
            sexPatient: this.item.sexPatient,
            age: this.$utilFront.obtainAgeWithLabel(this.item.birthDate),
            laboratoryLabel: this.item.laboratoryLabel,
          };
          if (this.info.modality.toUpperCase() === "COLPOSCOPIA") {
            StudyRequest.papanicolaouViewReport({
              idStudy: id,
              studyFiles: true
            })
            .then(({ data }) => {
              this.filePreviews = data.studyFiles;
              console.log("Archivos de colposcopia:", this.filePreviews);
            })
            .catch(err => console.error(err));
          }
          this.checkStatus();
          this.validateData();
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      }).finally(()=>{
        this.sending = false;
      });
    },

    viewFile(file) {
    try {
      const b64 = file.bytes.replace(/\s+/g, '');
      const byteChars = atob(b64);
      const byteNums = new Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        byteNums[i] = byteChars.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNums);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch (e) {
      console.error('Error al abrir archivo:', e);
      this.$utilFront.notifications('No se pudo abrir el archivo', 'ERROR');
    }
  },

    
    confirmBegin() {
      this.dialog = true;
    },
    confirmCancel() {
      this.dialog2 = true;
    },
    beginStudy() {
      this.sending = true;
      this.loader = true;
      let speciality = localStorage.getItem("speciality");
      let postID = {
        idStudy: this.info.idStudy,
        appointment: {
          speciality: speciality,
        },
      };
      StudyRequest.beginStudy(postID)
        .then((res) => {
          if (res.data.data) {
            if (res.data.code === 200 && res.data.status === "OK") {
              if (this.speciality == 3) {
                this.downloadBarcode(this.info.idStudy);
              }
              this.$utilFront.notifications(
                "Estudio iniciado correctamente",
                "SUCCESS"
              );
              this.$router.go(-1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(
                "Sucedio un error al iniciar estudio correct",
                "ERROR"
              );
            }
          }
        })
        .catch(function (e) {
          //console.log(e);
          this.$utilFront.notifications(
            "Ha ocurrido un error interno",
            "ERROR"
          );
        })
        .finally(() => {
          this.sending = false;
          this.loader = false;
        });
    },
    cancelStudy() {
      if (this.$refs.form.validate()) {
        this.sending = true;
        this.loader = true;
        let postID = {
          reason: this.reason,
          study: {
            idStudy: this.info.idStudy,
          },
        };
        StudyRequest.cancelStudy(postID)
          .then((res) => {
            if (res.data.data) {
              if (res.data.code === 200 && res.data.status === "OK") {
                this.$utilFront.notifications(
                  "Estudio cancelado correctamente",
                  "SUCCESS"
                );
                this.$router.go(-1);
                // this.$router.push({
                //   name: this.nameRoute,
                //   params: this.paramsRoute,
                // });
              } else if (res.data.code === 401) {
                this.unauthorized();
              } else {
                this.$utilFront.notifications(
                  "Sucedio un error al cancelar el estudio",
                  "ERROR"
                );
              }
            }
          })
          .finally(() => {
            this.sending = false;
            this.loader = false;
          });
      }
    },
    checkStatus() {
      if (this.info.status == 1) {
        this.visible = true;
      }
    },
    validateData() {
      if (this.prevRoute != null) {
        this.nameRoute = this.prevRoute.name;
      }
      this.paramsRoute = this.$route.params;
      let data = this.$route.params;
      this.acronym = "TD";
      if (!(typeof data.acronym === "undefined")) {
        this.acronym = data.acronym;
      }
      if (
        this.info.status == 5 ||
        this.info.status == 6 ||
        this.info.status == 14
      ) {
        this.visible2 = true;
      }
    },

    close() {
      try {
        let idStudy = localStorage.getItem("idStudy");
        //this.sending = true;
        //this.loader = true
        let data = {
          idStudy: idStudy,
        };
        this.reason = "";
        this.quantityImages = 0;
        if (this.speciality == 2) {
          StudyRequest.validatePACS(data)
            .then((res) => {
              let { data, status, code } = res.data;
              if (code == 200 && data >= 1) {
                this.quantityImages = data;
                this.dialogCloseStudy = true;
              } else if (code == 200 && data == false) {
                this.$utilFront.notifications(
                  "El estudio no cuenta con imágenes asignadas.",
                  "WARNING"
                );
              } else if (typeof data == "string") {
                this.$utilFront.notifications("Sucedio un error", "ERROR");
              } else {
                this.catchError();
              }
            })
            .catch(this.catchError)
            .finally(() => {
              //this.sending = false;
            });
        } else if (this.speciality == 3) {
          this.$router.push({
            name: "ResultadosLaboratorio",
            params: {
              idStudy: idStudy,
              readOnly: true,
              idPerson: this.$route.params?.idPerson,
            },
          });
        }
      } catch (e) {
        this.catchError(e);
      }
    },

    closeStudy(idStudy) {
      this.sending = true;
      this.loader = true;
      let postID = {
        idStudy: idStudy,
        quantityImages: this.quantityImages,
        observation: this.reasonClose,
        idUser: this.$utilFront.getIdUser(),
      };

      StudyRequest.closeStudy(postID)
        .then((res) => {
          if (res.data.data) {
            if (res.data.code === 200 && res.data.status === "OK") {
              for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].idStudy == study) {
                  this.list.splice(i, 1);
                }
              }
              this.$utilFront.notifications(
                "Estudio cerrado con correctamente",
                "SUCCESS"
              );
              this.$router.go(-1);
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(
                "Sucedio un error al cerrar el estudio",
                "ERROR"
              );
            }
          }
        })
        .finally(() => {
          this.sending = false;
          this.loader = false;
        });
    },
    cancel() {
      this.dialog2 = true;
    },
    showStatus() {
      return this.item.status <= 3;
    },
    closeCancel() {
      this.dialog2 = false;
      this.$refs.observer.reset();
      this.$refs.form.reset();
    },
    downloadBarcode(study) {
      this.sending = true;
      try {
        let data = {
          idStudy: study,
          fileName: "Codigo de barras",
          quantityTags: 1,
        };
        ReportPDFRequest.downloadBarcodeLaboratory(data);
      } catch (e) {
        this.catchError(e);
      } finally {
        this.sending = false;
        this.quantity = 1;
      }
    },
    downloadViewer(item) {
      try {
        this.loader = true;
        this.sending = true;
        let data = {
          idStudy: item,
          idBranchOffice: this.$utilFront.getIdBranchOffice(),
        };
        StudyRequest.findURLJNLP(data)
          .then((res) => {
            window.open(res.data, "_blank").focus();
          })
          .catch(this.catchError)
          .finally(() => {
            this.sending = false;
            this.loader = false;
          });
      } catch (e) {
        this.catchError(e);
      }
    },
   downloadZIP(item) {
  try {
    this.sending = true;
    let data = { idStudy: item };
    DownloadZipRequest.downloadImagesDCM(data)
      .then((res) => {
        // Construir el nombre del archivo con el formato: ApellidosNombres - ID.zip
        let filename = '';
        
        if (this.info.fullNamePatient && this.info.idPatient) {
          const nameParts = this.info.fullNamePatient.trim().split(/\s+/).filter(part => part !== '');
          const numParts = nameParts.length;
          
          if (numParts === 1) {
            filename = `${nameParts[0]} - ${this.info.idPatient}.zip`;
          } else {
            let apellidosCount;
            
            if (numParts === 2) {
              apellidosCount = 1;
            } else if (numParts === 3) {
              apellidosCount = 2;
            } else if (numParts === 4) {
              apellidosCount = 2;
            } else {
              apellidosCount = 2;
            }
            
            // Tomar los últimos elementos como apellidos
            const apellidos = nameParts.slice(-apellidosCount).join('');
            // Tomar los primeros elementos como nombres
            const nombres = nameParts.slice(0, -apellidosCount).join('');
            
            // Formato: Apellidos + Nombres
            filename = `${apellidos}${nombres} - ${this.info.idPatient}.zip`;
          }
        } else {
          filename = `Estudio-${item}.zip`;
        }

        const url = URL.createObjectURL(
          new Blob([res.data], {
            type: "application/zip",
          })
        );

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // Liberar memoria después de un tiempo
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 60000);
      })
      .catch(this.catchError)
      .finally(() => {
        this.sending = false;
      });
  } catch (e) {
    this.catchError(e);
  }
},
    downloadInterpretation(item) {
  console.log("jaksadd", item)
  let data = {
    idStudy: item,
    interpretationText: "",
    fileName: "Interpretacion",
  };
  this.sending = true;
  this.loader = true;
  ReportPDFRequest.downloadInterpretation1(data).then((res) => {
    // Construir el nombre del archivo con el formato: ApellidoPaternoApellidoMaternoNombres - ID.pdf
    let filename = '';
    let displayName = '';
    
    if (this.info.fullNamePatient && this.info.idPatient) {
      const nameParts = this.info.fullNamePatient.trim().split(/\s+/).filter(part => part !== '');
      const numParts = nameParts.length;
      
      if (numParts === 1) {
        filename = `${nameParts[0]} - ${this.info.idPatient}.pdf`;
        displayName = `${nameParts[0]} - ${this.info.idPatient}`;
      } else if (numParts === 2) {
        // Un nombre y un apellido: "Juan Pérez"
        const apellidoPaterno = nameParts[1];
        const nombres = nameParts[0];
        filename = `${apellidoPaterno}${nombres} - ${this.info.idPatient}.pdf`;
        displayName = `${apellidoPaterno}${nombres} - ${this.info.idPatient}`;
      } else {
        // 3 o más partes: determinar apellidos
        let apellidosCount;
        
        if (numParts === 3) {
          // Ejemplo: "María García López" -> 1 nombre, 2 apellidos
          apellidosCount = 2;
        } else if (numParts === 4) {
          // Ejemplo: "José Luis Hernández García" -> 2 nombres, 2 apellidos
          apellidosCount = 2;
        } else {
          // Para 5+ partes: 2 apellidos, el resto nombres
          apellidosCount = 2;
        }
        
        // Los últimos elementos son los apellidos (primero el paterno, luego el materno)
        const apellidos = nameParts.slice(-apellidosCount);
        // El resto son nombres
        const nombres = nameParts.slice(0, -apellidosCount).join('');
        
        // Orden correcto: apellido paterno + apellido materno + nombres
        const apellidoPaterno = apellidos[0];
        const apellidoMaterno = apellidos[1] || '';
        const apellidosCompletos = apellidoPaterno + apellidoMaterno;
        
        filename = `${apellidosCompletos}${nombres} - ${this.info.idPatient}.pdf`;
        displayName = `${apellidosCompletos}${nombres} - ${this.info.idPatient}`;
      }
    } else {
      filename = `Interpretacion-${item}.pdf`;
      displayName = `Interpretacion-${item}`;
    }

    const pdfBlob = new Blob([res.data], {
      type: "application/pdf",
    });
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Crear una página HTML que muestre el PDF con el título personalizado
    const htmlContent = `
<!DOCTYPE html>
<html>
<head>
    <title>${displayName}</title>
    <style>
        body, html {
            margin: 0;
            padding: 0;
            height: 100%;
            overflow: hidden;
        }
        embed {
            width: 100%;
            height: 100%;
            border: none;
        }
    </style>
</head>
<body>
    <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%">
</body>
</html>`;

    const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
    const htmlUrl = URL.createObjectURL(htmlBlob);

    // Abrir la página HTML en una nueva pestaña
    window.open(htmlUrl, '_blank');

    // También ofrecer la descarga directa con el nombre correcto
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Limpiar las URLs después de un tiempo
    setTimeout(() => {
      URL.revokeObjectURL(pdfUrl);
      URL.revokeObjectURL(htmlUrl);
    }, 60000);

    this.sending = false;
    this.loader = false;
  }).catch(error => {
    this.sending = false;
    this.loader = false;
    this.catchError(error);
  });
},
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
};
</script>
